import type { AdminScreenKey } from '@/nav/keys';

/** URL segment under /admin for each screen (basename already includes /admin). */
export const ADMIN_PATH_BY_SCREEN: Record<Exclude<AdminScreenKey, 'login'>, string> = {
  dashboard: 'dashboard',
  units: 'units',
  games: 'games',
  bills: 'bills',
  deposits: 'deposits',
  quickpay: 'quickpay',
  recharge: 'recharge',
  products: 'products',
  categories: 'categories',
  ordering: 'ordering',
  slides: 'slides',
  import: 'import',
  sources: 'sources',
  payments: 'payments',
  users: 'users',
  memberships: 'memberships',
  financial: 'financial',
  ussd: 'ussd',
  sham: 'sham-balance',
  executor: 'executor',
  sms: 'sms',
  security: 'security',
  site: 'site',
  password: 'password',
  support: 'support',
  notifications: 'notifications',
  account: 'account',
  controls: 'controls',
  compliance: 'compliance',
  staff: 'staff',
};

const SCREEN_BY_PATH = new Map<string, Exclude<AdminScreenKey, 'login'>>(
  Object.entries(ADMIN_PATH_BY_SCREEN).map(([screen, path]) => [
    path,
    screen as Exclude<AdminScreenKey, 'login'>,
  ]),
);

export const ADMIN_LOGIN_PATH = 'login';
export const ADMIN_DEFAULT_PATH = ADMIN_PATH_BY_SCREEN.dashboard;

export function adminPathForScreen(screen: AdminScreenKey): string {
  if (screen === 'login') return `/${ADMIN_LOGIN_PATH}`;
  return `/${ADMIN_PATH_BY_SCREEN[screen]}`;
}

export function adminScreenFromPath(pathname: string): AdminScreenKey | null {
  const segment = pathname.replace(/^\/+|\/+$/g, '').split('/')[0] ?? '';
  if (!segment) return null;
  if (segment === ADMIN_LOGIN_PATH) return 'login';
  return SCREEN_BY_PATH.get(segment) ?? null;
}

export function isAdminScreenPath(pathname: string): boolean {
  return adminScreenFromPath(pathname) !== null;
}
